<template>
    <div class="horizontal-links d-flex flex-wrap align-items-center">
        <!-- Título -->
        <div
            class="title body-medium font-weight-bold text-neutral-700 pe25 ps10 ps0-md d-block pb10 pb0-md"
        >
            {{ title }}
        </div>

        <div class="d-flex flex-wrap align-items-center" id="horizontal-links-list">
            <!-- Links -->
            <template v-for="(link, index) in partial" :key="index">
                <span
                    :title="link.title"
                    v-if="isActive(link.slug)"
                    class="d-flex align-items-center horizontal-link text-decoration-none body-small d-block border1 py4 ps12 pe8 br16 text-neutral-700 text-neutral-800-hover mx5"
                    :class="linkClasses(link)"
                >
                    <span class="d-block text-ellipsis">{{ link.title }}</span>
                    <a
                        v-if="link.parent_link"
                        :href="link.parent_link"
                        class="body-medium"
                        :class="`text-${color}-300 text-${color}-300-hover d-inline-block text-decoration-none  mb10 mb0-md`"
                    >
                        <i class="bx bx-x"></i>
                    </a>
                </span>
                <a
                    v-if="!isActive(link.slug)"
                    :title="link.title"
                    :href="link.url"
                    class="horizontal-link text-decoration-none body-small d-block border1 py4 px12 br16 text-neutral-700 text-neutral-800-hover mx5 text-ellipsis mb10 mb0-md"
                    :class="linkClasses(link)"
                >
                    {{ link.title }}
                </a>
            </template>

            <!-- Link "has more" -->
            <a
                v-if="hasMore"
                href="#"
                @click.prevent="isActionsheetOpen = true"
                class="horizontal-link text-decoration-none body-small d-block border1 py4 px12 br16 text-neutral-700 text-neutral-800-hover mx5 text-ellipsis"
                :class="linkClasses()"
            >
                + {{ hasMore }}
            </a>
        </div>

        <ActionSheet
            v-model="isActionsheetOpen"
            @close="isActionsheetOpen = false"
            :title="title"
        >
            <div class="d-flex flex-wrap align-items-center scroll-y">
                <div class="filter w-100 mb20">
                    <input
                        v-model="filter"
                        class="form-control br100"
                        placeholder="Filtrar"
                    />
                </div>

                <a
                    v-for="(link, index) in filteredLinks"
                    :key="index"
                    :href="link.url"
                    class="text-decoration-none body-small d-block border1 py4 px12 br16 text-neutral-700 text-neutral-800-hover me10 mb10 text-ellipsis me5"
                    :class="linkClasses(link)"
                >
                    {{ link.title }}
                </a>

                <a
                    v-if="filteredLinks.length === 0"
                    class="text-decoration-none body-small d-block border1 py4 px12 br16 text-neutral-700 text-neutral-800-hover me10 mb10 text-ellipsis me5"
                    :class="linkClasses(null)"
                >
                    Nenhum resultado
                </a>
            </div>
        </ActionSheet>
    </div>
</template>

<script>
import ActionSheet from "./ActionSheet.vue"
export default {
    name: "HorizontalLinks",
    components: {
        ActionSheet,
    },
    props: {
        title: {
            type: String,
            required: true,
        },
        links: {
            type: Array,
            default: () => [],
        },
        color: {
            type: String,
            default: "brand",
        },
        active: {
            type: String,
            default: null,
        },
        limit: {
            type: Number,
            default: 5,
        },
    },
    data() {
        return {
            isActionsheetOpen: false,
            filter: "",
            windowWidth: window.innerWidth
        }
    },
    computed: {
        changeLimit() {
            return this.windowWidth <= 768 ? 3 : this.limit
        },
        partial() {
            return this.allLinks.slice(0, this.changeLimit)
        },
        hasMore() {
            const excess = this.allLinks.length - this.changeLimit
            return excess > 0 ? excess : 0
        },
        allLinks() {
            return window.links || this.links
        },
        filteredLinks() {
            const links = this.allLinks

            if (this.filter) {
                return links.filter((link) =>
                    link.title.toLowerCase().includes(this.filter.toLowerCase())
                )
            }

            return links
        },
    },
    methods: {
        isActive(slug) {
            return slug === this.active
        },
        linkClasses(link = null) {
            let classes = [`bg-${this.color}-100`, `border-${this.color}-200`]

            if (link && this.isActive(link.slug)) {
                classes = [
                    `bg-${this.color}-500`,
                    `border-${this.color}-500`,
                    "text-secondary-100",
                    "text-secondary-100-hover",
                ]
            }

            return classes
        },
        handleResize() {
            this.windowWidth = window.innerWidth
        }
    },
    mounted() {
        window.addEventListener("resize", this.handleResize)
    },
    beforeUnmount() {
        window.removeEventListener("resize", this.handleResize)
    }
}
</script>

<style scoped>
.horizontal-link {
    max-width: 150px;
}
</style>
